import React from 'react';
import "./game.css";
// import Card from "./Card.jsx";
import Navbar from '../navbar/navbar.jsx';
import book1 from "./Dread Showdown.pdf";
import book2 from "./Quantum Nexus.pdf";
import book3 from "./Blitz space rule book.pdf";
import book4 from "./path blazzer.pdf";
import Card1 from '../Card1/Card1.jsx';
import Maincard from '../main_card/maincard.jsx';
import Footer from "../footer/footer.jsx";
import side from "./sidecut.png";

export default function Games() {

    const data = [
        {
            title : "Path Blazer",
            url: "https://res.cloudinary.com/dqrwkgoi8/image/upload/v1706947667/cnsbo99wpncg2xf2fzku.jpg",
            info : "Encounter the realm of 'Path Blazer' : A RoboRace competition! The goal of Path Blazer competition is to build a wired  robot to be operated manually and should travel through exciting turns and conquer all the obstacles. The robot that will finish the arena in minimal time will win this game.",
            register: "https://unstop.com/p/path-blazerrobo-race-rmageddon-2024-shri-guru-gobind-singhji-institute-of-engineering-and-technology-sggsiet-nanded-868057",
            rulebook: book4,
            id: "card1-4",
            id2: "card1-remove",
            no: "01"
        },
        {
            title : "Dread Showdown",
            url: "https://res.cloudinary.com/dqrwkgoi8/image/upload/v1706947673/iemhyuxhfe6qanldrmiv.jpg",
            info : "Dive into the thrilling world of 'Dread Showdown' : A Robo-Sumo competition! Customize your bots to battle it out in a confined arena. Operator should try to push the opponent's robot out of the arena but the one with the premier controlling & best tactics will win the bout.",
            register: "https://unstop.com/p/dread-shadow-bot-wrestling-rmageddon-2024-shri-guru-gobind-singhji-institute-of-engineering-and-technology-sggsiet-nan-868043",
            rulebook: book1,
            id: "card1-1",
            id2: "",
            no: "02"
        },
        {
            url: "https://res.cloudinary.com/dqrwkgoi8/image/upload/v1706947660/h6rn3y603dfmhgcqivxh.jpg",
            title : "Quantum Nexus",
            info : "Quantum nexus is a line follower competition.The goal of the Quantum Nexus competition is for a robot to accurately follow a black line on white surface, maneuver intricate paths and complete the arena in the shortest time possible. The robot that successfully routes the path line from start to finish in the quickest manner will win the competition.",
            register: "https://unstop.com/p/quantum-nexus-line-follower-rmageddon-2024-shri-guru-gobind-singhji-institute-of-engineering-and-technology-sggsiet-na-867988",
            rulebook: book2,
            id: "card1-2",
            id2: "",
            no: "03"
        },
        {
            title : "Blitz space",
            url: "https://res.cloudinary.com/dqrwkgoi8/image/upload/v1706947670/j0hssf3gl0j9xuskebjc.png",
            info : "Blitz Place is a dynamic pick-and-place robotics competition wherein robots showcase their precision and agility in picking up and placing objects with fineness. It challenges teams to build optimal bot which can navigate the arena, strategically grabbing and relocating items with delicacy.",
            register: "https://unstop.com/p/blitz-place-pick-place-rmageddon-2024-shri-guru-gobind-singhji-institute-of-engineering-and-technology-sggsiet-nanded-868047",
            rulebook: book3,
            id: "card1-3",
            id2: "",
            no: "04"
        }
        // {
        //     title : "HACKATHON : IN COLLABORATION WITH TEAM SWAG",
        //     url: "https://res.cloudinary.com/doiocpcni/image/upload/v1704735498/Rmageddon2K24/hackathon_uibsoa.png",
        //     info : "hackathon is a fast-paced, collaborative event where students with various skills converge to develop creative projects. In a specified time, teams work on coding, design, and business aspects to build prototypes and find innovative solutions.",
        //     register: "#game5",
        //     rulebook: "Sample.pdf",
        //     swag: 1
        // }
    ]

  return (
    <div id='games' className='game-main'>
        <img src={side} alt='animage' className='side-img'></img>
        <Navbar />
        <p className='main-game-head' >Events</p>
        <Maincard />
        <div className='games-card-container'>
            {data.map((key) => {
                return <Card1 title={key.title} info={key.info} rulebook={key.rulebook} register={key.register} idname={key.id} idname2={key.id2} no={key.no} />
            })}
        </div>
        <Footer />
    </div>
  )
}
